import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cqms-failing-patients',
  templateUrl: './cqms-failing-patients.component.html',
  styleUrls: ['./cqms-failing-patients.component.css']
})
export class CqmsFailingPatientsComponent implements OnInit {


  displayedColumns: string[] = ['PatientId', 'Patient', 'Age', 'Gender', 'Race',
    'Ethnicity', 'Language', 'Performed', 'LastValues', 'Status', 'Action',];
  //dataSource1 = ELEMENT_DATA;
  constructor(private router: Router) { }


  onClickFilling() {
    this.router.navigate(['CqmsFailingPatient']);
  }
  ngOnInit() {
  }

}
